<template>
  <div>
    <div class="con-tab-ejemplo">
      <vs-list>
        <vs-list-header></vs-list-header>
        <vs-list-item v-for="res in callHistories" :key="res.id" :title="`${convFormatSeq(res.seq)} ${convFormatDateTime(res.callDate)}`" :subtitle="`${res.remark}`">
          <vs-button class="btn-icon" :disabled="disabledDelCallHistory" size="small" color="danger" v-show="!isHideDelCallHistory(res) && visibleDelCallHistory" @click="delCallHistory(res.id)">ลบ</vs-button>
        </vs-list-item>
        <div class="mt-2">
          <vs-textarea class="w-full mt-2 mb-2" v-show="visibleTextarea" v-model="form.callHistory.remark" rows="5"/>
          <vs-button class="btn-icon mr-2" size="small" color="success" @click="addCallHistory()" v-show="visibleAddCallHistory">เพิ่มข้อมูล</vs-button>
          <vs-button class="btn-icon mr-2" size="small" color="success" v-show="visibleReceiveCallHistory" @click="receiveCallHistory()">รับงาน</vs-button>
          <vs-button class="btn-icon mr-2" size="small" color="warning" v-show="visibleUnReceiveCallHistory" @click="unReceiveCallHistory()">ยกเลิกรับงาน</vs-button>
          <vs-alert :active.sync="visibleSuggestion" color="warning" :title="$t('suggestion.paymentSuggestion.title')" close-icon="icon-x" icon="icon-info" icon-pack="feather">
            <p>{{ receivedSuggestion }}
              <vs-button class="btn-icon p-2 float-right" size="small" color="warning" @click="unReceiveCallHistory()">ยกเลิกรับงาน</vs-button>
            </p>
          </vs-alert>
        </div>
      </vs-list>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import {createNamespacedHelpers, mapState} from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');
const { mapActions: mapNotificationActions} = createNamespacedHelpers('Notification');
export default {
  data () {
    return {
      form:{
        callHistory:{
          remark: ""
        }
      }
    }
  },
  async created () {
    // console.log(this.contract)
  },
  computed:{
    ...mapState(['currentUser']),
    ...mapAccountingState([
      'status',
      'contract',
      'callHistories',
    ]),
     visibleDelCallHistory(){
      return this.contract.callHistoriesReceivedBy.id === this.currentUser.id
    },
    visibleTextarea(){
      return this.contract.callHistoriesReceivedBy.id === this.currentUser.id
    },
    visibleReceiveCallHistory(){
      return this.contract.callHistoriesReceivedBy.id !== this.currentUser.id && this.contract.callHistoriesReceivedStatus === "Disabled"
    },
    visibleUnReceiveCallHistory(){
      return this.contract.callHistoriesReceivedBy.id === this.currentUser.id
    },
    visibleAddCallHistory(){
      return this.contract.callHistoriesReceivedBy.id === this.currentUser.id
    },
    visibleSuggestion(){
      return this.contract.callHistoriesReceivedBy.id !== this.currentUser.id && this.contract.callHistoriesReceivedStatus === "Enabled"
    },
    receivedSuggestion(){
      let prefix = ""
      if(this.contract.callHistoriesReceivedBy.prefix){prefix = this.contract.callHistoriesReceivedBy.prefix.nameTh}
      let callHistoriesReceivedBy = prefix+this.contract.callHistoriesReceivedBy.name+" "+this.contract.callHistoriesReceivedBy.surname
      return `${callHistoriesReceivedBy} กำลังติดตามงานดังกล่าว เวลา ${this.convFormatDateTime(this.contract.callHistoriesReceivedAt)}`
    },
  },
  methods: {
    ...mapAccountingActions([
      'callHistoriesReceived',
      'callHistoriesUnReceived',
      'createCallHistory',
      'deleteCallHistory',
    ]),
    ...mapNotificationActions(['getNotifications']),
    // Function CallHistory
    isHideDelCallHistory (res){
      if( res.seq >= this.callHistories.length){
        return false
      }
      return true
    },
    async receiveCallHistory(){
      await this.callHistoriesReceived({
        form: {
          id: this.contract.id,
        },
        vm: this
      })
    },
    async unReceiveCallHistory(){
      await this.callHistoriesUnReceived({
        form: {
          id: this.contract.id,
        },
        vm: this
      })
    },
    async addCallHistory(){
      await this.createCallHistory({
        contractId: this.contract.id,
        form: {
          remark: this.form.callHistory.remark,
        },
        vm: this
      })
      this.form.callHistory.remark = ""
      this.getNotifications()
    },
    async delCallHistory(id){
      const vm = this
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: vm.acceptDelCallHistory
      })
    },
    async acceptDelCallHistory () {
      await this.deleteCallHistory({
        form: {
          id: this.actionID
        },
        vm: this
      })
      this.getNotifications()
    },
    convFormatSeq(val){
      return `ครั้งที่ ${val}`
    },
    convFormatDateTime(val){
      return `${moment(val).format("วันที่ DD-MM-YYYY เวลา HH.mm น.")}`
    }
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
